<template>
  <ul id="list-tasks">
    <li>
      <div class="oblea" @click="selectItem">
        <div id="imagenProductoContainer">   
          <img id="check" src="/dist/icon-check.png"  v-show="item.showCheck" /> 
          <div :id="`semaforo${semaforoVal}`" v-show="item.ManejaStock"> </div>
          <!-- <div :id="`semaforo${semaforoVal}`"> </div> -->
          <img id="imagenProducto" :src="imagenProducto" :title="item.Nombre"  v-show='imagenProducto != null'/> 
        </div>   
        <div class="fh cc"  style="font-size: 10px; font-weight: 500; color: rgb(194, 126, 43); margin-top: 6px; margin-bottom: -6px" v-show="esProducto">Cod {{item.Codigo}}</div> 
        <p id="labelProducto">{{item.Nombre}}</p> 
      </div>
    </li>
  </ul>
</template>


<script>
  import axios from 'axios'

  export default {
    name: 'item-realizar-pedido',
    props: ['item'],

    computed: {
      semaforoVal() {
        // console.log('<<1>>') 
        // console.log(this.item.ManejaStock) 
        var actual = Number(this.item.StockActual)
        var minimo = Number(this.item.StockMinimo) 
        if (actual > minimo) {
          return 'V';
        }
        else if ((0 < actual) && (actual <=minimo)) {
          return 'A';
        }
        else if (actual <= 0) {
          return 'R';
        }
      },
      esProducto() {
        if ((this.item.Codigo != null) && (this.item.Codigo.length > 0)) {
          return true   
        }
        else {
          return false
        }
      },
      imagenProducto() {
        if (this.item.ImagenUrl != null) {
          return this.item.ImagenUrl
        }
        else {
          return '/dist/placeholder-producto.png'
        } 
      } 
    },


    methods: {
      selectItem () {
         this.$emit('setItem', this.item.Id);
      },
    },

   }
</script>


<style scoped>


#semaforoV {
    width: 10px; 
    height: 15px;
    display: block;
    border-radius: 100%;
    background: #4CD964;
    position: absolute;
    width: 15px;
    left: 115px;
    top: 100px;
    z-index: 2;
    display: block;
   }



  #semaforoA {
    width: 10px; 
    height: 15px;
    display: block;
    border-radius: 100%;
    background: #FFF242;
    position: absolute;
    width: 15px;
    left: 115px;
    top: 100px;
    z-index: 2;
    display: block;
  }
  
  

  #semaforoR {
    width: 10px; 
    height: 15px;
    display: block;
    border-radius: 100%;
    background: red;
    position: absolute;
    width: 15px;
    left: 115px;
    top: 100px;
    z-index: 2;
    display: block;
  }



#check{
    position: absolute;
    width: 20px;
    left: 117px;
    top: 5px;
    z-index: 1;
    display: block;
  }


#imagenProductoContainer{
    width: 110px;
    height: 100px;
    display: flex;
    justify-content: center;  
    align-items: center;  
    border-radius: 10px;
    border-width: 1px;
    border: 1px solid #dddddd;
    padding: 10px 15px 10px 15px;
    box-shadow: 4px 4px 7px #dddddd;  
  }


#imagenProducto{
    position: relative;
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
    display: block;
    border-radius: 10 px;
  }


 * {
   margin:  0;
   padding: 0;
  }


  li {
   float: left;
   display: block;
   padding: 10px;
   text-decoration: none;
  }

.oblea{
    position: relative;
    width: 130px;
    height: 160px;
    background: #ffffff;
  }
        
  #imagenProductoContainer:hover{
    cursor: pointer;
    background: #f9f9f9;
  }   

#labelProducto{
  margin-top: 8px;
  text-align: center;
  font-size:10px; 
  font-weight: 500;
  background-color: #ffffff; 
  color: #4969B2;
  }
           
        
 </style>


// WEBPACK FOOTER //
// src/components/views/realizarPedido/itemRealizarPedido.vue